export const lang= { 
			 home: 'Home',
			 faq: 'FAQ',
			 settings: 'Settings',
			 facebook: 'Facebook',
			 twitter: 'Twitter',
			 copylink: 'Copy Link',
			 linkUrl: 'http://quiz.dip.com.sg',
			 ans_details:'Drag left or right to answers',
			 yes:'Me',
			 no_w1:'Not',
			 no_w2:'Me',
			 card1:'I do not conform to norms because I am not afraid to express myself.',	
			 card2:'Every now and then, I like to try on different styles and looks to entertain myself.',
			 card3:'I enjoy challenging myself and bungee jumping is on my bucket list.',
			 card4:'I like to look sharp and put my best face forward.',
			 card5:'I challenge myself to high intensity activities on the weekends rather than coffee with friends.',
			 card6:'Life can be overwhelming and demanding but I know my efforts will pay off.',
			 card7:'I never hesitate to help others whenever I can.',
			 card8:'On weekends, I prefer to be with my loved ones at the beach than partying with my friends.',
			 card9:'I prefer to achieve goals at my own pace, and it may not be what others expect.',
			 card10:'I love the natural glow of the "no makeup" makeup look.',
			 card11:'I read all the ingredients that go into a product before using them because I am very careful about what goes into my body.',
			 card12:'I am always looking out for the naturally healthier choice.',
			 card13:'I prefer to read an interesting book than attend a social event.',
			 card14:'I am all about making informed choices as to impulse purchases.',
			 card15:'Organic, natural products are always my top beauty choices.',
			 card16:'My weekends are spent at museums and galleries or a concert instead of a movie.',
			 card17:'Feeling and looking good naturally while aging gracefully is what I desire most.',
			 card18:'I am always mindful about choosing safe and trusted quality products and don’t mind paying a premium for them.',
			 card19:'I prefer beauty treatments that has minimum or no downtime so I can hop right back without missing a beat!',
			 card20:'Being real matters to me. All my choices are authentic to who I am.',
			 result1_title1:'YOU ARE UNIQUELY,',
			 result1_title2:'GENUINELY AUTHENTIC',
			 result2_title1:'YOU ARE INTELLIGENTLY,',
			 result2_title2:'INTUITIVELY DECISIVE',
			 result3_title1:'YOU ARE ABSOLUTELY,',
			 result3_title2:'BOLDLY CONFIDENT',
			 result4_title1:'YOU ARE SIMPLY,',
			 result4_title2:'EFFORTLESSLY ME',
			 arrow_text1:'Discoveries',
			 arrow_text2:'made for you',
			 result1:'You are true to yourself and you value the real things that matters the most to you. You appreciate where you are in life now and will continue to pursue the finer things in life. Looking good as you age is important to you and you will only choose the most authentic products that promise results. You are a role model to your circle of friends.',
			 result2:'You are smart and always make informed choices. Your friends will come to seek your opinions and you are highly valued. You will not settle for second-best and will opt for a better choice when you know there is one out there. You believe strongly in reliability, safety and results. Organic and natural products are always your preferred choice.',
			 result3:'You are bold and confident because you are unafraid to show yourself. Many people wait around for the right opportunity but you know your priorities and pair your actions with fearless choices in life. Similarly to other like-minded personalities, you understand that greater rewards come from taking greater risks because you are not afraid to put your bold and confident face forward.',
			 result4:'You value your ‘me’ time and you always manage it effortlessly whether it’s at work or at play. Setbacks don’t stop you. Instead, they inspire you with a greater determination to reach your goals. You value the attraction of self-beauty because it inspires confidence in every aspect of your life. Most importantly, you know how to conquer your fears, eliminate doubt and find positivity to overcome unfavourable circumstances effortlessly.',
			 
};


// WEBPACK FOOTER //
// ./src/lang-th.js